module.exports = __webpack_public_path__ + "static/media/logob.0cd5bc56.png";